import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { WishlistButtonWithApi } from '@packages/modules/src/WishlistButtonWithApi/WishlistButtonWithApi';
import { Price } from '@packages/modules/src/Price/Price';
import { Box, Image, Stack } from '@packages/shared';
import { ProductOverviewFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductOverviewFragmentFragmentDoc';
import { TaxHint } from '../../TaxHint';

/* GraphQL */ `
  fragment ProductOverviewFragment on Product {
    sku
    name
    price {
      ...ProductPriceFragment
    }
    media {
      type
      url
    }
    delivery {
      ...TaxHintFragment
    }
    availability {
      state
    }
    ...AddToBasketFragment
  }
`;

type ProductOverviewProps = {
  /**
   * Product data fragment
   */
  productData: FragmentType<typeof ProductOverviewFragmentFragmentDoc>;
};

/**
 * Product overview component for rating page
 */
export const ProductOverview = ({ productData }: ProductOverviewProps) => {
  const product = getFragmentData(ProductOverviewFragmentFragmentDoc, productData);
  const { media, price, delivery, sku, name, availability } = product;

  return (
    <Stack gap={2} flexDirection="row">
      <Box
        sx={{
          width: '100%',
          maxWidth: 196,
          '.ProductOverview-image-wrapper': { position: 'relative', width: '100%', pb: '100%' },
        }}
      >
        <Box className="ProductOverview-image-wrapper">
          <Image
            src={media[0].url}
            style={{
              objectFit: 'contain',
            }}
            fill
            alt=""
            sizes="25vw"
          />
        </Box>
      </Box>
      <Stack justifyContent="space-between" flexGrow={1}>
        <Stack>
          <Price data={price} />
          <TaxHint data={delivery} />
        </Stack>
        <WishlistButtonWithApi
          sku={sku}
          productName={name}
          iconOnly={false}
          availability={availability.state}
        />
      </Stack>
    </Stack>
  );
};
